export default __webpack_public_path__ + "static/OREA-037c59f0ce06ae18798e169b5237cb44.png";